<template>
  <div id="app" v-cloak>
    <router-view/>
  </div>
</template>

<script>
//import contentData from "@/assets/content.js";

import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      title: "Adoptuj pszczołę i chroń z nami zapylacze!",
      contentA: "",
      loader: true,
    };
  },
  provide() {
    const content = {};
    const loader = {};

    Object.defineProperty(content, "data", {
      get: () => this.contentA,
    });
    Object.defineProperty(loader, "data", {
      get: () => this.loader,
    });

    return {
      content,
      loader,
    };
  },
  methods: {
    getData: function () {
      axios
          .get("https://bogini2.greenpeace.pl/api/v1/json-documents/ap12/content", {
            headers: {crossDomain: true},
          })
          .then((response) => {
            this.contentA = response.data;
            this.loader = false;
          })
          .catch((e) => {
            console.log("error", e);
          });
    },
    setAbCookieFromUrlValue() {
      const urlParams = new URLSearchParams(window.location.search);
      const testab = urlParams.get('ab'); // Assuming 'slug' is the parameter name
      const testAbContebt = `test_ab_content${testab}`;
      if (testab) {
        document.cookie = `vue-ab-cookie=${testAbContebt}; expires=Fri, 31 Dec 2025 23:59:59 GMT`;
      }
    }
  },
  beforeMount: function () {
    this.setAbCookieFromUrlValue();
    this.getData();
  },
  updated() {
    let type = "Pozostałe";

    //, Formularz zamówienia (strona formularza adopcji), Potwierdzenie zamówienia (strona z potwierdzeniem złożenia zamówienia), Błąd 404
    if (this.$route.fullPath == "/") {
      type = "Strona główna";
    }
    if (this.$route.fullPath == "/kontakt") {
      type = "Kontakt";
    }
    if (this.$route.fullPath.includes("pytania-i-odpowiedzi")) {
      type = "Pytania i odpowiedzi";
    }
    if (this.$route.fullPath.includes("error")) {
      type = "Błąd 404";
    }
    if (this.$route.fullPath.includes("thankyou_")) {
      type = " Potwierdzenie zamówienia";
    }

    window.trackUrl(document.title + " | " + this.$route.fullPath, type);
  },
};

window.trackAdoptionForm = function () {
  //console.log("trackAdoption");
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "virtualPageview",
    virtualPageURL: "/formularz-adopcji",
    virtualPageTitle: "Formularz zamówienia",
    pageType: "Formularz zamówienia",
    viewForm: "1",
  });
};

window.trackUrl = function (title, type) {
  //console.log("trackUrl");
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "virtualPageview",
    virtualPageURL: window.location.pathname,
    virtualPageTitle: title,
    pageType: type,
  });
};
window.trackClickButton = function (buttonName) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "clickButton",
    buttonName: buttonName,
    buttonAdopt: "1",
  });
};

window.trackFormClick = function (event, formName, fieldName, clickField) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: event,
    formName: formName,
    fieldName: fieldName,
    clickField: clickField,
  });
};

window.goToPayment = function () {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "formSubmitted",
    formName: "Formularz Adoptuję",
    sendForm: "1",
  });
};

window.clickAdoptujButton = function () {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "clickButton",
    buttonName: "Przycisk Adoptuję",
    buttonAdopt: "1",
  });
};

window.formFieldClick = function (fieldName) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "formClickField",
    formName: "Formularz Adoptuję",
    fieldName: fieldName,
    clickField: "1",
  });
};

window.errorOnFormField = function (fieldName, errorMessage) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "formFieldError",
    formName: "Formularz Adoptuję",
    fieldName: fieldName,
    errorMessage: errorMessage,
    errorField: "1",
  });
};
</script>

<style lang="scss">
@import "src/assets/scss/main.scss";
</style>
